import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  sk: {
    translation: {
      seoTitle: "Palivová kalkulačka Fuely | Výpočet ceny cesty autom",
      seoDescription: "Palivová kalkulačka Fuely počíta cenu cesty autom alebo elektromobilom podľa trasy, spotreby, ceny paliva, elektriny, meny a mýta.",
      welcome: "Palivová kalkulačka Fuely",
      enter_location: "Vyhľadajte miesto...",
      calculate: "Vypočítať trasu a náklady",
      reset: "Reset",
      start: "Štart",
      destination: "Cieľ",
      avoidHighways: "Vyhnúť sa diaľniciam",
      
      fuelConsumptionImperial: "Spotreba (MPG):",
      fuelPrice: "Cena paliva:",
      electricityPrice: "Cena elektriny",
      distance: "Vzdialenosť",
      fuelUsed: "Spotrebované palivo",
      fuelCost: "Odhadované náklady na palivo",
      selectRoute: "Vyberte alternatívnu trasu:",
      openNavigation: "Otvoriť navigáciu v Google Maps",
      fuelUnitMetric: "l/100km",
      fuelUnitImperial: "MPG",
      travelTime: "Čas cesty",
      currency: "Mena",
      consumptionModeLabel: "Výber spôsobu zadania spotreby:",
      autoConsumptionOption: "Vybrať z tabuľky",
      manualConsumptionOption: "Zadať manuálne",
      selectCar: "Vyberte auto",
      year: "Rok:",
      selectYear: "Vyberte rok",
      brand: "Značka:",
      selectBrand: "Vyberte značku",
      model: "Model:",
      selectModel: "Vyberte model",
      engine: "Motorizácia:",
      selectEngine: "Vyberte motorizáciu",
      transmission: "Prevodovka:",
      selectTransmission: "Vyberte prevodovku",
      contactTitle: "Kontaktujte nás",
      contactMessage: "Ak máte akékoľvek pripomienky alebo ste narazili na chybu, napíšte nám:",
      contactEmail: "Kontaktný formulár",
      nameLabel: "Meno:",
      emailLabel: "Email:",
      messageLabel: "Správa:",
      submitLabel: "Odoslať",
      thankYouMessage: "Ďakujeme za vašu spätnú väzbu!",
      cookieTitle: "Upozornenie na cookies",
      cookieDescription: "Fuely používa nevyhnutné úložisko a po súhlase aj analytiku, spätnú väzbu a reklamné technológie.",
      cookiePolicyLink: "Prečítajte si naše pravidlá cookies",
      cookieAccept: "Prijať",
      calculating: "Počítam...",
      darkMode: "Tmavý režim",
      lightMode: "Svetlý režim",
      
      detailTitle: "Palivová kalkulačka - výpočet nákladov, spotreby a ceny paliva",
      detailParagraph1: "Palivová kalkulačka, niekedy nazývaná aj fuel cost calculator, slúži na rýchly a presný výpočet nákladov na cestu. Stačí zadať vzdialenosť, spotrebu vozidla a cenu paliva, a okamžite zistíš, koľko ťa cesta zhruba vyjde. To je mimoriadne užitočné najmä pri dlhších trasách, kde môžu náklady rapídne stúpať.",
      detailParagraph2: "V dobe, keď ceny pohonných hmôt kolíšu a rozdiel medzi jednotlivými čerpacími stanicami môže byť značný, je výhodné mať prehľad. Naša aplikácia Fuely ti umožňuje brať do úvahy aj aktuálne kurzy mien, ak cestuješ za hranice. Okrem toho môžeš zvoliť alternatívne trasy, vyhnúť sa diaľniciam a vopred odhadnúť, či je pre teba lepšia krátka, no drahšia cesta, alebo dlhšia a lacnejšia varianta.",
      detailParagraph3: "Navyše, tým že budeš vedieť náklady na cestu vopred, môžeš lepšie spravovať svoj rodinný rozpočet. Nezaskočí ťa tak nečakaná suma na čerpacej stanici a vyhneš sa stresu, že minieš viac, než si plánoval.",
      detailParagraph4: "Fuely počíta s viacerými typmi ciest: každodenné dochádzanie, víkendové výlety, firemné jazdy aj dlhé zahraničné trasy. Ak pridáš zastávky medzi štart a cieľ, vzdialenosť aj výsledok sa prepočítajú automaticky bez samostatného tlačidla.",
      detailParagraph5: "Pre presnejší odhad odporúčame použiť reálnu spotrebu vozidla namiesto katalógovej hodnoty. Pri elektromobile môžeš zadať spotrebu v kWh/100 km a cenu elektriny, takže vieš porovnať náklady spaľovacieho auta a elektrického vozidla v jednom nástroji.",
      detailParagraph6: "Výsledok ber ako praktický cestovný rozpočet. Skutočnú cenu ovplyvní premávka, rýchlosť, počasie, plne naložené auto, štýl jazdy, mýto, diaľničné známky a aktuálna cena paliva na konkrétnej čerpacej stanici.",
      planningTitle: "Ako Fuely počíta náklady na cestu",
      planningHeadingDistance: "Vzdialenosť medzi štartom a cieľom",
      planningDistanceText: "Najdôležitejší vstup je vzdialenosť trasy. Môžeš ju zadať ručne alebo vybrať štart a cieľ cez Google Maps. Ak pridáš zastávku, Fuely prepočíta celkovú vzdialenosť, čas jazdy a výpočet nákladov na cestu.",
      planningHeadingFuelPrice: "Spotreba vozidla a cena paliva",
      planningFuelPriceText: "Presnosť výsledku závisí od spotreby vozidla a ceny paliva. Pri benzíne a nafte zadaj litre na 100 km alebo MPG, pri elektromobile spotrebu v kWh. Fuely potom ukáže odhad, výsledok výpočtu, spotrebované palivo alebo energiu.",
      planningHeadingCurrencies: "Meny vrátane EUR a USD",
      planningCurrenciesText: "Pri zahraničnej trase môžeš meniť menu výsledku. Podpora EUR, USD a ďalších mien pomáha porovnať náklady na palivo, elektrinu, mýto a diaľničné poplatky ešte pred cestou.",
      
      faqTitle: "Často kladené otázky (FAQ)",
      faqQ1: "Ako spoľahlivé sú údaje v palivovej kalkulačke?",
      faqA1: "Spoľahlivosť závisí od presnosti tvojich vstupov (spotreba, cena paliva). Aplikácia Fuely môže zohľadňovať rôzne faktory, no nemôže predvídať napr. dopravné zápchy či prudký nárast cien paliva v daný deň.",
      faqQ2: "Prečo je vhodné zadať presnú spotrebu môjho auta?",
      faqA2: "Každé auto má inú reálnu spotrebu. Ak zadáš hodnotu z katalógu, môže sa líšiť od reality. Presnejšie údaje prinesú presnejší výpočet nákladov.",
      faqQ3: "Aké výhody prináša fuel cost calculator pre cestujúcich do zahraničia?",
      faqA3: "Pri cestách do zahraničia sa ti hodí prepočet do inej meny alebo informácia o cenách paliva v zahraničí. Fuely dokáže zohľadniť reálne kurzy a pomôcť ti vybrať trasu s najvýhodnejšími nákladmi.",
      faqQ4: "Môžem pomocou Fuely kalkulovať aj dlhodobé náklady na palivo?",
      faqA4: "Áno. Pokiaľ zadáš rôzne trasy, Fuely ti môže pomôcť vypočítať napr. mesačné či ročné náklady na palivo, ak jazdíš pravidelne tú istú trasu.",
      faqQ5: "Podporuje Fuely zastávky na trase?",
      faqA5: "Áno. Medzi štart a cieľ môžeš pridať viacero zastávok. Trasa, vzdialenosť, čas jazdy aj náklady sa aktualizujú automaticky.",
      faqQ6: "Je výpočet vhodný aj pre elektromobily?",
      faqA6: "Áno. Po prepnutí na elektrické vozidlo zadáš spotrebu energie a cenu elektriny. Fuely potom odhadne náklady podobne ako pri benzíne alebo nafte.",
      faqQ7: "Ako získať presnejší výpočet nákladov na cestu?",
      faqA7: "Zadaj skutočnú spotrebu auta, aktuálnu cenu paliva alebo elektriny, správnu vzdialenosť a očakávané poplatky. Pri trase so zastávkami skontroluj štart, cieľ a každú medzizastávku.",
      faqQ8: "Môžem počítať náklady v USD alebo inej mene?",
      faqA8: "Áno. Fuely podporuje viacero mien vrátane EUR a USD. Vďaka tomu vieš pred cestou porovnať cenu paliva, elektriny a poplatkov aj pri jazde do zahraničia.",
      
      fuelDropdownTitle: "Vyberte krajinu a druh paliva",
      fuelDropdownPetrol: "Benzín",
      fuelDropdownDiesel: "Nafta",
      fuelDropdownClose: "Zavrieť",
      fuelDropdownLoading: "Načítavam...",
      fuelDropdownError: "Nepodarilo sa načítať dáta.",
      fuelDropdownCountriesTitle: "Dostupné krajiny",
      searchCountry: "Vyhľadať krajinu",
      
      emissions: "Emisie CO₂",
      fuelTypeLabel: "Typ paliva",
      fuelTypeGasoline: "Benzín",
      fuelTypeDiesel: "Nafta",
      
      selectFuelType: "Vyberte typ paliva",
      fuelDataNotice: "Aktuálne pracujeme na rozšírení údajov o typoch paliva pre presnejšie výsledky.",
      appVersion: "Verzia aplikácie:",
      updated: "Aktualizované:",
      vehicleType: "Typ vozidla",
      combustionVehicle: "Motorové vozidlo",
      electricVehicle: "Elektrické vozidlo",
      combustion: "Spaľovacie",
      electric: "Elektrické",
      efficiency: "Spotreba energie",
      enterEfficiency: "Zadajte spotrebu v kWh/100km",
      autoEfficiency: "Automaticky zistená spotreba",
      efficiencyShort: "kWh/100km",
      fuelConsumptionMetric: "Spotreba (l/100km):",
      efficiencyMetricShort: "kWh/100km",
      efficiencyImperialShort: "kWh/100mi",
      efficiencyImperial: "Efektivita (kWh/100mi):",
      efficiencyMetric: "Efektivita (kWh/100km):",
      battery: "Batéria",
      selectBattery: "Vyberte batériu",
      rateUs: "Ohodnoťte nás",
      stars: "hviezdičiek",
      optionalComment: "Volitelný komentár...",
      submitRating: "Odoslať hodnotenie",
      ratingTitle: "Ako sa Vám páči Fuely?",
      sendButton: "Odoslať",
      placeholder: "Napíšte komentár (voliteľné)",
      ratingHint: "Krátke hodnotenie nám pomáha zlepšovať kalkulačku.",
      ratingClose: "Zavrieť hodnotenie",
      ratingSubmitting: "Odosielam...",
      ratingSubmitSuccess: "Ďakujeme, hodnotenie bolo odoslané.",
      ratingSubmitError: "Hodnotenie sa nepodarilo odoslať. Skúste to prosím neskôr.",
      cookieDeny: "Zamietnuť",
      shareApp: "Zdieľať aplikáciu",
      distanceHint: "Po výbere štartu a cieľa sa vzdialenosť aktualizuje automaticky.",
      advancedOptions: "Pokročilé možnosti",
      tolls: "Mýto a diaľničné poplatky",
      stops: "Zastávky",
      stop: "Zastávka",
      stopsDescription: "Pridajte miesta, cez ktoré má trasa viesť.",
      addStop: "Pridať zastávku",
      removeStop: "Odstrániť",
      noStops: "Trasa zatiaľ nemá žiadne medzizastávky.",
      liveEstimate: "Aktualizuje sa automaticky",
      estimatedRange: "Odhadovaný rozsah",
      exactCalculation: "Presný výpočet",
      basedOn: "Vypočítané z",
      actualCostNote: "Skutočné náklady sa môžu líšiť podľa štýlu jazdy, premávky, trasy a ceny paliva.",
      updatingRoute: "Aktualizujem trasu...",
      resultWaitingTitle: "Výsledok čaká na údaje",
      resultNeedsDistance: "Zadajte vzdialenosť alebo vyberte štart a cieľ.",
      resultNeedsConsumption: "Zadajte spotrebu vozidla.",
      resultNeedsFuelPrice: "Zadajte cenu paliva alebo elektriny.",
      route: "Trasa",
      moreAboutCalculator: "Viac o palivovej kalkulačke",
      advertisement: "Reklama",
      relatedGuidesTitle: "Návody na výpočet nákladov na cestu",
      locationSearchLoadError: "Vyhľadávanie miest sa nepodarilo načítať.",
      locationSearchRequestError: "Vyhľadávanie miest zlyhalo. Skontrolujte nastavenia Google API.",
      locationMissingCoordinates: "Vybrané miesto nemá dostupnú polohu.",
      locationDetailsError: "Podrobnosti vybraného miesta sa nepodarilo načítať.",
      googleMapsLoadError: "Google Maps sa nepodarilo načítať. Skontrolujte API kľúč.",
      routeError_REQUEST_DENIED: "Google odmietol výpočet trasy. Skontrolujte billing a aktiváciu Directions API.",
      routeError_ZERO_RESULTS: "Medzi vybranými miestami sa nenašla trasa pre auto.",
      routeError_NOT_FOUND: "Štart alebo cieľ sa nepodarilo priradiť ku konkrétnemu miestu.",
      routeError_OVER_QUERY_LIMIT: "Bol prekročený limit požiadaviek Google Maps. Skúste to neskôr.",
      routeError_INVALID_REQUEST: "Vyberte štart a cieľ z ponuky miest.",
      routeError_UNKNOWN_ERROR: "Google Maps dočasne nedokázal vypočítať trasu. Skúste to znova.",
      routeErrorGeneric: "Trasu sa nepodarilo vypočítať ({{status}}).",
      mapPreviewTitle: "Mapa trasy sa zobrazí po výbere miest",
      mapPreviewText: "Vyberte štart a cieľ z ponuky miest. Fuely potom zobrazí trasu, zastávky a odhad nákladov na ceste.",

    }
  },
  en: {
    translation: {
      seoTitle: "Fuely Fuel Cost Calculator | Trip Cost and Route Estimate",
      seoDescription: "Fuely estimates fuel and EV trip costs from route distance, consumption, fuel price, electricity price, currency, stops and tolls.",
      welcome: "Fuely fuel cost calculator",
      fuelConsumptionMetric: "Fuel consumption (l/100km):",
      enter_location: "Search location...",
      calculate: "Calculate route and costs",
      reset: "Reset",
      start: "Start",
      destination: "Destination",
      avoidHighways: "Avoid highways",
      battery: "Battery",
      selectBattery: "Select a battery",
      fuelConsumptionImperial: "Fuel consumption (MPG):",
      fuelPrice: "Fuel cost:",
      electricityPrice: "Electricity price",
      distance: "Distance",
      fuelUsed: "Fuel used",
      fuelCost: "Estimated fuel cost",
      selectRoute: "Select an alternative route:",
      openNavigation: "Open navigation in Google Maps",
      fuelUnitMetric: "l/100km",
      fuelUnitImperial: "MPG",
      travelTime: "Travel time",
      currency: "Currency",
      consumptionModeLabel: "Select consumption input mode:",
      autoConsumptionOption: "Choose from table",
      manualConsumptionOption: "Enter manually",
      selectCar: "Select a car",
      year: "Year:",
      selectYear: "Select a year",
      brand: "Brand:",
      selectBrand: "Select a brand",
      model: "Model:",
      selectModel: "Select a model",
      engine: "Engine:",
      selectEngine: "Select an engine",
      transmission: "Transmission:",
      selectTransmission: "Select a transmission",
      contactTitle: "Contact Us",
      contactMessage: "If you have any comments or encountered an error, please let us know:",
      contactEmail: "Contact form",
      nameLabel: "Name:",
      emailLabel: "Email:",
      messageLabel: "Message:",
      submitLabel: "Send",
      thankYouMessage: "Thank you for your feedback!",
      cookieTitle: "Cookie Notice",
      cookieDescription: "Fuely uses essential storage and, with consent, analytics, feedback and advertising technologies.",
      cookiePolicyLink: "Read our cookie policy",
      cookieAccept: "Accept",
      calculating: "Calculating...",
      darkMode: "Dark mode",
      lightMode: "Light mode",
      
      detailTitle: "Fuel cost calculator - distance, consumption and fuel price",
      detailParagraph1: "A fuel cost calculator, sometimes simply called a palivová kalkulačka, is a quick and accurate tool for estimating your travel expenses. By inputting the distance, your vehicle’s fuel consumption, and the fuel price, you can immediately see how much your trip is likely to cost. This is particularly helpful for longer routes where expenses can rapidly increase.",
      detailParagraph2: "In a time when fuel prices fluctuate and there can be significant differences between gas stations, having an overview is crucial. Our Fuely app also lets you factor in real-time currency exchange rates if you’re traveling abroad. You can select alternate routes, avoid highways, and figure out whether a shorter but more expensive route is better for you than a longer, cheaper alternative.",
      detailParagraph3: "Moreover, knowing your travel expenses in advance helps you manage your budget more effectively. You won’t be caught off guard by unexpected fuel costs, and you can avoid the stress of spending more than you planned.",
      detailParagraph4: "Fuely works for many trip types: commuting, weekend travel, business mileage and long international routes. Add stops between the start and destination and the distance, time and cost estimate update automatically.",
      detailParagraph5: "For better accuracy, use your real-world consumption instead of only the catalog value. For electric vehicles, enter kWh/100 km or kWh/100 mi and your electricity price to compare EV and combustion trip costs in one calculator.",
      detailParagraph6: "Use the result as a practical travel budget. Real costs can change with traffic, speed, weather, vehicle load, driving style, tolls, highway fees and the exact fuel price at the station.",
      planningTitle: "How Fuely calculates trip costs",
      planningHeadingDistance: "Distance between start and destination",
      planningDistanceText: "The most important input is route distance. Enter it manually or choose a start and destination with Google Maps. When you add stops, Fuely recalculates total distance, travel time and the trip cost estimate.",
      planningHeadingFuelPrice: "Vehicle consumption and fuel price",
      planningFuelPriceText: "Accuracy depends on vehicle consumption and fuel price. For petrol and diesel, enter liters per 100 km or MPG; for an electric vehicle, enter kWh consumption. Fuely then shows the estimate, calculated result and energy used.",
      planningHeadingCurrencies: "Currencies including EUR and USD",
      planningCurrenciesText: "For international routes, change the result currency. Support for EUR, USD and other currencies helps compare fuel, electricity, toll and highway-fee costs before the trip.",
      
      faqTitle: "Frequently Asked Questions (FAQ)",
      faqQ1: "How reliable are the figures in the fuel cost calculator?",
      faqA1: "The reliability depends on the accuracy of your inputs (fuel consumption, fuel price). While Fuely can account for various factors, it can’t predict traffic jams or sudden price spikes on a given day.",
      faqQ2: "Why should I enter my car’s exact fuel consumption?",
      faqA2: "Each vehicle has a different real-world consumption. Using a catalog value might differ from actual usage. More accurate data leads to more accurate cost calculations.",
      faqQ3: "What advantages does a fuel cost calculator offer for traveling abroad?",
      faqA3: "If you’re heading abroad, it’s useful to convert to another currency or factor in foreign fuel prices. Fuely can take real exchange rates into account and help you choose the route with the most efficient costs.",
      faqQ4: "Can Fuely help calculate my long-term fuel expenses?",
      faqA4: "Yes. If you input different routes, Fuely can assist in estimating monthly or yearly fuel costs, especially if you regularly drive the same route.",
      faqQ5: "Does Fuely support stops on the route?",
      faqA5: "Yes. You can add multiple stops between the start and destination. Route distance, travel time and costs update automatically.",
      faqQ6: "Is the calculator suitable for electric vehicles?",
      faqA6: "Yes. Switch to an electric vehicle, enter energy consumption and electricity price, and Fuely estimates the trip cost similarly to petrol or diesel.",
      faqQ7: "How can I get a more accurate trip cost estimate?",
      faqA7: "Use real vehicle consumption, current fuel or electricity price, the correct distance and expected tolls. For a route with stops, check the start, destination and every intermediate stop.",
      faqQ8: "Can I calculate costs in USD or another currency?",
      faqA8: "Yes. Fuely supports multiple currencies including EUR and USD, so you can compare fuel, electricity and toll costs before international travel.",
      
      fuelDropdownTitle: "Choose Country & Fuel Type",
      fuelDropdownPetrol: "Petrol",
      fuelDropdownDiesel: "Diesel",
      fuelDropdownClose: "Close",
      fuelDropdownLoading: "Loading...",
      fuelDropdownError: "Failed to load data.",
      fuelDropdownCountriesTitle: "Available countries",
      searchCountry: "Search a country",
      shareApp: "Share this app",
      emissions: "CO₂ Emissions",
      fuelTypeLabel: "Fuel type",
      fuelTypeGasoline: "Gasoline",
      fuelTypeDiesel: "Diesel",
      selectFuelType: "Select fuel type",
      fuelDataNotice: "We are currently working on expanding fuel type data for more accurate results.",
      appVersion: "App version:",
      updated: "Updated:",
      vehicleType: "Vehicle Type",
      combustionVehicle: "Combustion Vehicle",
      electricVehicle: "Electric Vehicle",
      efficiency: "Energy consumption",
      enterEfficiency: "Enter consumption in kWh/100km",
      autoEfficiency: "Automatically detected consumption",
      efficiencyShort: "kWh/100km",
      efficiencyMetricShort: "kWh/100km",
      efficiencyImperialShort: "kWh/100mi",
      efficiencyImperial: "Efficiency (kWh/100mi):",
      efficiencyMetric: "Efficiency (kWh/100km):",
      combustion: "Combustion",
      electric: "Electric",
      ratingTitle: "How do you like Fuely?",
      sendButton: "Submit",
      placeholder: "Write a comment (optional)",
      ratingHint: "A quick rating helps us improve the calculator.",
      ratingClose: "Close rating",
      ratingSubmitting: "Submitting...",
      ratingSubmitSuccess: "Thank you, your rating was submitted.",
      ratingSubmitError: "The rating could not be submitted. Please try again later.",
      cookieDeny: "Deny",
      distanceHint: "Distance updates automatically after you select a start and destination.",
      advancedOptions: "Advanced options",
      tolls: "Tolls",
      stops: "Stops",
      stop: "Stop",
      stopsDescription: "Add places that the route should pass through.",
      addStop: "Add stop",
      removeStop: "Remove",
      noStops: "This route has no intermediate stops yet.",
      liveEstimate: "Updates automatically",
      estimatedRange: "Estimated range",
      exactCalculation: "Exact calculation",
      basedOn: "Based on",
      actualCostNote: "Actual cost may vary depending on driving style, traffic, route, and fuel price.",
      updatingRoute: "Updating route...",
      resultWaitingTitle: "Your result is waiting",
      resultNeedsDistance: "Enter a distance or select a start and destination.",
      resultNeedsConsumption: "Enter the vehicle consumption.",
      resultNeedsFuelPrice: "Enter a fuel or electricity price.",
      route: "Route",
      moreAboutCalculator: "More about the fuel calculator",
      advertisement: "Advertisement",
      relatedGuidesTitle: "Trip cost calculation guides",
      locationSearchLoadError: "Location search could not be loaded.",
      locationSearchRequestError: "Location search failed. Check the Google API configuration.",
      locationMissingCoordinates: "The selected place has no available coordinates.",
      locationDetailsError: "The selected place details could not be loaded.",
      googleMapsLoadError: "Google Maps could not be loaded. Check the API key.",
      routeError_REQUEST_DENIED: "Google rejected the route request. Check billing and the Directions API configuration.",
      routeError_ZERO_RESULTS: "No driving route was found between the selected places.",
      routeError_NOT_FOUND: "The start or destination could not be matched to a place.",
      routeError_OVER_QUERY_LIMIT: "The Google Maps request limit was exceeded. Try again later.",
      routeError_INVALID_REQUEST: "Select the start and destination from the location suggestions.",
      routeError_UNKNOWN_ERROR: "Google Maps could not calculate the route temporarily. Try again.",
      routeErrorGeneric: "The route could not be calculated ({{status}}).",
      mapPreviewTitle: "The route map appears after selecting places",
      mapPreviewText: "Choose a start and destination from the location suggestions. Fuely will then show the route, stops and trip cost estimate.",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'sk',
    detection: {
      order: ['querystring', 'htmlTag', 'navigator'],
      caches: []
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
